import { render, staticRenderFns } from "./CommissionsReport.vue?vue&type=template&id=0daf3fd2&"
import script from "./CommissionsReport.vue?vue&type=script&lang=js&"
export * from "./CommissionsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports